import HeroSection from "../heroSection/HeroSection";
import BookingForm from "../heroSection/BookingForm";
import ServiceSection from "../serviceSection/ServiceSection";
import ExpressSection from "../expressSection/ExpressSection";
import InfoSection from "../infoSection/InfoSection";
import ShipmentAndVehicles from "../vehicleSection/ShipmentAndVehicles";
import DriverHomeSection from "../driverHomeSection/DriverHomeSection";
import TestimonialsSection from "../testimonialsSection/TestimonialsSection";
import InformationSection from "../informationSection/InformationSection";
import TransportTabs from "../transportAccordion/TransportTabs";
import heroPhoto from "../../assets/images/hero-bg3.jpg";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import SEO from "../SEO";
import AppDownloadSection from "../heroSection/AppDownloadSection";

export default function HomeBooking() {
  const navigate = useNavigate();
  const location = useLocation(); // عشان نقرأ query params
  const { t } = useTranslation();

  // Redirect مؤقت لو الرابط القديم فيه token & email
  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const token = query.get("token");
    const email = query.get("email");

    if (token && email) {
      // حوّلي المستخدم مباشرة لـ ResetPasswordGuestPage
      navigate(
        `/set-password?token=${encodeURIComponent(token)}&email=${encodeURIComponent(email)}`,
      );
    }
  }, [location, navigate]);

  return (
    <>
      <SEO
        title="Kurier- & Direkttransport online buchen | TransCirox"
        description="Direkttransport für, Paletten -Pakete und Dokumente. Einfach online buchen, schnelle Abholung und sichere Bezahlung mit TransCirox."
        keywords="Umzug, Umzugsfirma, Umzugsservice, Umzugshelfer, Möbeltransport, Möbelumzug, Wohnungsumzug, Firmenumzug, Umzug günstig, Umzug Kosten, Umzug Preise, Umzug schnell, Umzug sofort, Umzug Angebot, Transportfirma Deutschland"
      />
      <HeroSection
        backgroundImage={heroPhoto}
        title={t("HomeBooking.hero.title")}
        titleHighlight={t("HomeBooking.hero.titleHighlight")}
        features={[
          t("HomeBooking.hero.features.feature1"),
          t("HomeBooking.hero.features.feature2"),
          t("HomeBooking.hero.features.feature3"),
          t("HomeBooking.hero.features.feature4"),
          t("HomeBooking.hero.features.feature5"),
          t("HomeBooking.hero.features.feature6"),
          t("HomeBooking.hero.features.feature7"),
        ]}
        showQuoteForm={false}
        formType="booking"
        formComponent={<BookingForm />}
      />

      <ServiceSection isAfterHeroForm={true} />
      <ExpressSection />
      <InfoSection />
      <ShipmentAndVehicles />
      <DriverHomeSection />
      <AppDownloadSection />
      <TestimonialsSection />
      <InformationSection />
      <TransportTabs />
    </>
  );
}
